import Login from '@/pages/auth/login/Login'
import EnterPass from '@/pages/auth/EnterPass'
import Choose from '@/pages/auth/Choose'
import RemoveAccount from '@/pages/auth/RemoveAccount'

export default [
    {
        name: 'login',
        path: '/login',
        component: Login,
        meta: {
            layout: 'default',
            requiresAuth: false
        }
    },
    {
        path: '/enter-password',
        component: EnterPass,
        props: (route) => ({
            username: route.query.username,
            color: route.query.color
        }),
        meta: {
            layout: 'default',
            requiresAuth: false
        }
    },
    {
        path: '/choose-an-account',
        component: Choose,
        meta: {
            requiresAuth: false
        }
    },
    {
        path: '/remove-account',
        component: RemoveAccount,
        meta: {
            requiresAuth: false
        }
    }
]
